import { useEffect, useState } from "react";
import { buzz } from "../lib/haptics";

// The screen blows out to near-white, then resolves into what is next.
//
// This is the hinge between dark and light: out of the countdown into the
// questions, and out of the dark play into the lit reveal. "The truth blooms
// into the light" is meant literally, so it is a real screen transition rather
// than a card treatment.

export function WhiteBloom({ onDone, haptic = true }: { onDone?: () => void; haptic?: boolean }) {
  const [gone, setGone] = useState(false);

  useEffect(() => {
    if (haptic) buzz("commit");
    const t = window.setTimeout(() => { setGone(true); onDone?.(); }, 1000);
    return () => window.clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (gone) return null;
  return <div className="white-bloom" aria-hidden="true" />;
}
